import React, { useState } from "react";

import about1 from "../../assets/img/about/Dzielnica_Podgorze.jpg";
import about2 from "../../assets/img/about/Pensjonat_Margarita_budynek_glowny_ul_Graniczna_Duszniki_Zdroj_1.jpg";
import about3 from "../../assets/img/about/Pensjonat_Margarita_budynek_glowny_ul_Graniczna_Duszniki_Zdroj_2.jpg";
import about4 from "../../assets/img/about/Pensjonat_Margarita_ul_Graniczna_Duszniki_Zdroj_1.jpg";
import about5 from "../../assets/img/about/Pensjonat_Margarita_ul_Graniczna_Duszniki_Zdroj_2.jpg";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import FsLightbox from "fslightbox-react";

function HistoricalPhotos() {
  const [toggler, setToggler] = useState(false);
  const [activeImage, setActiveImage] = useState(1);
  const [images, setImages] = useState([
    about1,
    about2,
    about3,
    about4,
    about5,
  ]);

  const service = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 900,
    autoplay: true,
    slidesToShow: 3,
    // centerMode: true,
    // centerPadding: "60px",
    draggable: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section id="services" className="services-area pt-1 pt-xl-5 pb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 centered-column">
              <h2 className="display-5">Miejsce z bogatą historią</h2>
              <div className="mb-5">
                <p>
                  Dolina Podgórza dynamicznie rozwinęła się w latach
                  dwudziestych dwudziestego wieku. Wtedy też rozbudowany został
                  budynek opisany jako Margareten- Baude. Zlokalizowany był tu
                  ośrodek szkolenia niemieckiej zimowej kadry olimpijskiej z
                  infrastrukturą: dwie skocznie narciarskie, tor saneczkowy i
                  bobslejowy, trasy zjazdowe i biegowe. Poniżej zamieszczamy
                  historyczne zdjęcia udostępnione dzięki uprzejmości{" "}
                  <a href="https://polska-org.pl/" target="_blank">
                    polska-org.pl
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-12 col-md-12">
              <Slider className="slider-about" {...service}>
                <div>
                  <div className="single-services mb-30">
                    <div className="services-thumb">
                      <Link
                        to="#"
                        className="gallery-link popup-image"
                        onClick={() => {
                          setToggler(!toggler);
                          setActiveImage(1);
                        }}
                      >
                        <img src={about1} alt="img" />
                      </Link>
                    </div>
                    <div className="services-content">
                      <p>
                        Schronisko Margaretenbaude , Gospoda „Grillenhäusel“
                        oraz skocznia narciarska.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="single-services mb-30">
                    <div className="services-thumb">
                      <Link
                        to="#"
                        className="gallery-link popup-image"
                        onClick={() => {
                          setToggler(!toggler);
                          setActiveImage(2);
                        }}
                      >
                        <img src={about2} alt="img" />
                      </Link>
                    </div>
                    <div className="services-content">
                      <p>
                        Schronisko Margaretenbaude, gospoda Grillenhäusel oraz
                        skocznia narciarska w dzielnicy Podgórze.
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="single-services mb-30">
                    <div className="services-thumb">
                      <Link
                        to="#"
                        className="gallery-link popup-image"
                        onClick={() => {
                          setToggler(!toggler);
                          setActiveImage(3);
                        }}
                      >
                        <img src={about3} alt="img" />
                      </Link>
                    </div>
                    <div className="services-content">
                      <p>Dawne schronisko Margaretenbaude.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="single-services mb-30">
                    <div className="services-thumb">
                      <Link
                        to="#"
                        className="gallery-link popup-image"
                        onClick={() => {
                          setToggler(!toggler);
                          setActiveImage(4);
                        }}
                      >
                        <img src={about4} alt="img" />
                      </Link>
                    </div>
                    <div className="services-content">
                      <p>Zimowa panorama Podgórza. Gospoda Grillenhäusl.</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="single-services mb-30">
                    <div className="services-thumb">
                      <Link
                        to="#"
                        className="gallery-link popup-image"
                        onClick={() => {
                          setToggler(!toggler);
                          setActiveImage(5);
                        }}
                      >
                        <img src={about5} alt="img" />
                      </Link>
                    </div>
                    <div className="services-content">
                      <p>
                        Dawna gospoda „Grillenhäusel“ w Dusznikach-Podgórzu.
                      </p>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
          <div className="row">
            <div className="col pt-80">
              <h4>Linki do zdjęć:</h4>
              <ol
                className="historical-link-list"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  listStyleType: "upper-roman",
                }}
              >
                <li>
                  1.{" "}
                  <a
                    href="https://polska-org.pl/3405216,foto.html?idEntity=533537"
                    target="_blank"
                  >
                    Schronisko Margaretenbaude, gospoda Grillenhäusel oraz
                    skocznia narciarska w dzielnicy Podgórze.
                  </a>
                </li>
                <li>
                  2.{" "}
                  <a
                    href="https://polska-org.pl/775385,foto.html?idEntity=533537"
                    target="_blank"
                  >
                    Schronisko Margaretenbaude , Gospoda „Grillenhäusel“ oraz
                    skocznia narciarska.
                  </a>
                </li>
                <li>
                  3.{" "}
                  <a
                    href="https://polska-org.pl/4557272,foto.html?idEntity=533537"
                    target="_blank"
                  >
                    Zimowa panorama Podgórza. Gospoda Grillenhäusl.
                  </a>
                </li>
                <li>
                  4.{" "}
                  <a
                    href="https://polska-org.pl/4565303,foto.html?idEntity=533537"
                    target="_blank"
                  >
                    Dawna gospoda „Grillenhäusel“ w Dusznikach-Podgórzu.
                  </a>
                </li>
                <li>
                  5.{" "}
                  <a
                    href="https://polska-org.pl/3411039,foto.html?idEntity=533523"
                    target="_blank"
                  >
                    Dawne schronisko Margaretenbaude.
                  </a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <FsLightbox toggler={toggler} sources={images} slide={activeImage} />
    </>
  );
}

export default HistoricalPhotos;
